var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2,43.89L50.43,11.22c-.18-.67-.77-1.13-1.46-1.13H15.04c-.69,0-1.29,.46-1.46,1.13L4.8,43.89c-.2,.74,.19,1.51,.9,1.8l20.45,8.1c.84,.33,1.78-.14,2.02-1.02l3.83-14.27,3.83,14.27c.24,.87,1.18,1.35,2.02,1.02l20.44-8.1c.72-.29,1.12-1.06,.91-1.8h0Zm-8.77-20.97c-5.7-.7-10.57-4.46-12.69-9.8h10.05l2.64,9.8ZM16.19,13.13h9.9c-2.1,5.29-6.9,9.03-12.53,9.79l2.63-9.79Zm22.13,37.22l-4.86-18.08c-.4-1.49-2.52-1.49-2.93,0l-4.84,18.08-17.62-6.97,4.66-17.34c7.65-.5,14.22-5.62,16.59-12.91h5.21c2.39,7.34,9.03,12.47,16.74,12.92l4.66,17.33-17.61,6.97Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBottom);
export default __webpack_public_path__ + "static/media/icon_bottom.a842e151.svg";
export { ForwardRef as ReactComponent };